import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ApproveModal from "../../../Components/Common/ApproveModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import handleValidDate from "../../../helpers/utils/handleValidDate";

import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { setClientSelect, setCompanySelect, setBranchSelect } from "../../../store/app/action";
import { resetPositionState, getPosition } from "../../../store/position/action";
import { getAccAccount, resetAccAccountState } from "../../../store/accAccount/action";
import { resetLoanTermState, getLoanTerm as onGetLoanTerms, addNewLoanTerm as onAddNewLoanTerm, updateLoanTerm as onUpdateLoanTerm, deleteLoanTerm as onDeleteLoanTerm, getLoanTermLoading } from "../../../store/loanTerm/action";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import ExportDoc from "../../../Components/Common/ExportDoc";

const LoanTerm = () => {
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const [pageIdx, setPageIdx] = useState(0);
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, loanTerms, isLoanTermCreated, isLoanTermSuccess, loading, error, companies, companyLoading, positions, positionLoading, clientLoading, clients, accAccounts, accAccountLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    loanTerms: state.LoanTerm.loanTerms,
    isLoanTermCreated: state.LoanTerm.isLoanTermCreated,
    isLoanTermSuccess: state.LoanTerm.isLoanTermSuccess,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    clientLoading: state.Client.loading,
    clients: state.Client.clients,
    loading: state.LoanTerm.loading,
    error: state.LoanTerm.error,
    positions: state.Position.positions,
    positionLoading: state.Position.loading,
    accAccounts: state.AccAccount.accAccounts,
    accAccountLoading: state.AccAccount.loading,
  }));

  const [loanTermList, setLoanTermList] = useState([]);
  const [loanTermDoc, setLoanTermDoc] = useState([]);
  const [loanTerm, setLoanTerm] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [interestType, setInterestType] = useState([]);
  const [approveModal, setApproveModal] = useState(false);
  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [positionList, setPositionList] = useState([]);
  const [accountingList, setAccountingList] = useState([]);

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    },
  ];

  const interestTypeData = [
    {
      options: [
        { label: "Efektif", value: "Effective" },
        { label: "Flat", value: "Flat" },
      ],
    },
  ];

  const onClickDelete = (loanTerm) => {
    setLoanTerm(loanTerm);
    setDeleteModal(true);
  };

  const handleDeleteLoanTerm = () => {
    if (loanTerm) {
      dispatch(onDeleteLoanTerm(loanTerm));
      setDeleteModal(false);
    }
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  // useEffect(() => {
  //   setLoanTermList(loanTerms);
  // }, [loanTerms]);

  useEffect(() => {
    if (!isEmpty(loanTerms)) {
      let filteredLoanTerms = loanTerms;
      if (activeTypeTab !== "all") {
        filteredLoanTerms = loanTerms.filter((loanTerm) => loanTerm.loan_term_status.name === activeTypeTab);
      }
      setLoanTermList(filteredLoanTerms.map((el) => ({ ...el, isChecked: false })));
    }
  }, [loanTerms]);

  useEffect(() => {
    // if (data.loan_term_position && data.loan_term_position.length) {
    //   data.loan_term_position.forEach(item => {
    //     const position_name = item.loan_term_position_position.name;
    //     const id = item.positionId;
    //     var obj = { label: position_name, value: id };
    //     arrPosition.push(obj);
    //   });
    // }

    // setLoanTerm({
    //   id: data.id,
    //   description: data.description,
    //   startat: data.startat,
    //   name: data.name,
    //   interest: data.interest,
    //   interest_type: data.interest_type,
    //   period: data.period,
    //   amount: data.amount,
    //   account: data.loan_term_acc_account && {
    //     label: data.loan_term_acc_account.name,
    //     value: data.loan_term_acc_account.id,
    //   },
    //   accountInterest: data.loan_term_interest_account && {
    //     label: data.loan_term_interest_account.name,
    //     value: data.loan_term_interest_account.id,
    //   },
    //   client: {
    //     label: data.loan_term_client.name,
    //     value: data.loan_term_client.id,
    //   },
    //   company: {
    //     label: data.loan_term_company.name,
    //     value: data.loan_term_company.id,
    //   },
    //   position: arrPosition,
    // });

    let dataDoc = [
      {
        id: "name",
        label: "Nama",
        isSelected: true,
        data: [],
      },
      {
        id: "startat",
        label: "Tanggal Berlaku",
        isSelected: true,
        data: [],
      },
      {
        id: "interest_type",
        label: "Interest Type",
        isSelected: true,
        data: [],
      },
      {
        id: "interest",
        label: "Interest Rates",
        isSelected: true,
        data: [],
      },
      {
        id: "period",
        label: "Max Loan Tenor (Month) ",
        isSelected: true,
        data: [],
      },
      {
        id: "amount",
        label: "Interest Max Loan Amount",
        isSelected: true,
        data: [],
      },
      {
        id: "loan_term_acc_account",
        label: "Receivable Account",
        isSelected: true,
        data: [],
      },
      {
        id: "loan_term_interest_account",
        label: "Interest Revenue Account",
        isSelected: true,
        data: [],
      },
      {
        id: "loan_term_position",
        label: "Allowed Position ",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
      {
        id: "loan_term_client",
        label: "Grup Usaha",
        isSelected: true,
        data: [],
      },
      {
        id: "loan_term_company",
        label: "Perusahaan",
        isSelected: true,
        data: [],
      },
    ];

    if (loanTermList.length > 0) {
      loanTermList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);
            if (doc) {
              if (doc.id === "loan_term_client" || doc.id === "loan_term_company" || doc.id === "loan_term_acc_account" || doc.id === "loan_term_interest_account") {
                doc.data.push(value?.name ?? "");
              } else if (doc.id === "startat") {
                doc.data.push(value !== null ? handleValidDate(value) : "-");
              } else if (doc.id === "loan_term_position") {
                let arrPosition = [];
                if (value && value.length) {
                  value.forEach((item) => {
                    const position_name = item.loan_term_position_position.name;
                    arrPosition.push(position_name);
                  });
                }
                doc.data.push(arrPosition.length > 0 ? arrPosition.join(",") : "");
              } else {
                doc.data.push(value ?? "-");
              }
            }
          });
        }
      });
    }

    setLoanTermDoc(dataDoc);
  }, [loanTermList]);

  useEffect(() => {
    if (companySelected) {
      dispatch(resetLoanTermState());
      dispatch(onGetLoanTerms({ companyId: companySelected.value }));
      handleGetPosition(companySelected.value);
      handleGetAccAccount(companySelected.value);
    }
  }, [companySelected]);

  const handleGetPosition = (companyId) => {
    dispatch(resetPositionState());
    dispatch(getPosition({ companyId: companyId, status: 2 }));
  };

  const handleGetAccAccount = (companyId) => {
    dispatch(resetAccAccountState());
    dispatch(getAccAccount({ companyId: companyId, status: 2 }));
  };

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(positions)) {
      var data = [];
      var opt = [{ label: "Select All", value: "all" }];
      positions.forEach((item, key) => {
        const position_name = item.name;
        const departmentId = item.departmentId;
        const name = item.position_department && item.position_department && item.position_department.name;
        const id = item.id;
        var obj = { label: position_name, value: id, positionId: id, position_name: position_name, departmentId: departmentId, name: name };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setPositionList(data);
    }
  }, [positions]);

  useEffect(() => {
    if (!isEmpty(accAccounts)) {
      var data = [];
      var opt = [];
      accAccounts.forEach((item, key) => {
        const name = item.name;
        const code = item.code;
        const id = item.id;
        var obj = { label: code + " " + name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setAccountingList(data);
    }
  }, [accAccounts]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredLoanTerms = loanTerms;
      if (type !== "all") {
        filteredLoanTerms = loanTerms.filter((loanTerm) => loanTerm.loan_term_status.name === type);
      }
      setLoanTermList(filteredLoanTerms);
    }
  };

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setLoanTerm(null);
    } else {
      setModal(true);
    }
  }, [modal, dispatch]);

  const handleLoanTermClick = useCallback(
    (arg) => {
      const data = arg;
      let arrPosition = [];

      if (data.loan_term_position && data.loan_term_position.length) {
        data.loan_term_position.forEach((item) => {
          const position_name = item.loan_term_position_position.name;
          const id = item.positionId;
          var obj = { label: position_name, value: id };
          arrPosition.push(obj);
        });
      }

      setLoanTerm({
        id: data.id,
        description: data.description,
        startat: data.startat,
        name: data.name,
        interest: data.interest,
        interest_type: data.interest_type,
        period: data.period,
        amount: data.amount,
        account: data.loan_term_acc_account && {
          label: data.loan_term_acc_account.name,
          value: data.loan_term_acc_account.id,
        },
        accountInterest: data.loan_term_interest_account && {
          label: data.loan_term_interest_account.name,
          value: data.loan_term_interest_account.id,
        },
        client: {
          label: data.loan_term_client.name,
          value: data.loan_term_client.id,
        },
        company: {
          label: data.loan_term_company.name,
          value: data.loan_term_company.id,
        },
        position: arrPosition,
      });

      setIsEdit(true);
      toggle();
    },
    [toggle, dispatch]
  );

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteLoanTerm(element.value));
    });
    checkall.checked = false;
  };

  const handleApproveEmployee = () => {
    if (loanTerm) {
      loanTerm.setApprove = true;
      dispatch(onUpdateLoanTerm(loanTerm));
      dispatch(resetLoanTermState());
      dispatch(onGetLoanTerms());
      setApproveModal(false);
    }
  };

  function currencyFormat(num) {
    return "Rp " + parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = loanTermList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setLoanTermList(updated);
    setIsCheckAll(allChecked);
  };

  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = loanTermList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setLoanTermList(updatedData);
                }}
              />
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateLoanTerm") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      handleLoanTermClick(data);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("deleteLoanTerm") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      data.statusId = 3;
                      onClickDelete(data);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>
                </UncontrolledButtonDropdown>
              </ButtonGroup>
              {data.statusId === 1 && (
                <button
                  className={userType === "admin" || userType === "client" || userType === "company" ? "btn-label btn btn-sm btn-soft-success fs-12 ms-1" : userRole && userRole.split(",").indexOf("approveLoanTerm") !== -1 ? "btn-label btn btn-sm btn-soft-success fs-12 ms-1" : "btn-label btn btn-sm btn-soft-success fs-12 ms-1 d-none"}
                  onClick={() => {
                    data.statusId = 2;
                    setLoanTerm(data);
                    setApproveModal(true);
                  }}
                >
                  <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i> Approve
                </button>
              )}
            </div>
          );
        },
      },
      {
        Header: "Nama Termin",
        accessor: "name",
        filterable: true,
      },
      {
        Header: "Nominal Maksimal",
        accessor: "amount",
        filterable: true,
        Cell: (col) => <> {currencyFormat(col.row.original.amount)} </>,
      },
      {
        Header: "Bunga",
        accessor: "interest",
        filterable: true,
        Cell: (col) => <> {col.row.original.interest} %</>,
      },
      {
        Header: "Tenor",
        accessor: "period",
        filterable: true,
      },
      {
        Header: "Akun",
        accessor: "loan_term_acc_account.name",
        filterable: true,
        Cell: (cell) => {
          return (
            <span>
              {cell.row.original.loan_term_acc_account && cell.row.original.loan_term_acc_account.code} - {cell.row.original.loan_term_acc_account && cell.row.original.loan_term_acc_account.name}
            </span>
          );
        },
      },
      {
        Header: "Keterangan",
        accessor: "description",
        filterable: true,
      },
      {
        Header: "Date",
        accessor: "startat",
        filterable: true,
        Cell: (interest) => <> {handleValidDate(interest.row.original.startat)} </>,
      },
      {
        Header: "Status",
        accessor: "loan_term_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "DRAFT":
              return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
            case "ACTIVE":
              return <span className="badge text-uppercase badge-soft-info"> {cell.value} </span>;
            case "INACTIVE":
              return <span className="badge text-uppercase badge-soft-danger"> {cell.value} </span>;
            default:
              return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
          }
        },
      },
    ],
    [loanTermList, handleLoanTermClick, userType, userRole, isCheckAll]
  );

  const [filterDate, setFilterDate] = useState(null);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = loanTermList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setLoanTermList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => loanTermList, [loanTermList]);

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: pageIdx,
        pageSize: 10,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    setPageIdx(page);
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr[1]) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    var name = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      name: name,
    };
    dispatch(onGetLoanTerms(param));
  }

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      name: (loanTerm && loanTerm.name) ?? "",
      startat: loanTerm && loanTerm.startat,
      interest: (loanTerm && loanTerm.interest) || 0,
      interest_type: (loanTerm && loanTerm.interest_type) || "Flat",
      period: (loanTerm && loanTerm.period) || 0,
      amount: (loanTerm && loanTerm.amount) || 0,
      description: (loanTerm && loanTerm.description) ?? "",
      position: loanTerm && loanTerm.position,
      client: (loanTerm && loanTerm.client) || clientSelected,
      company: (loanTerm && loanTerm.company) || companySelected,
      account: (loanTerm && loanTerm.account) ?? "",
      accountInterest: (loanTerm && loanTerm.accountInterest) ?? "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Pick Term Name"),
      interest: Yup.string().required("Please Enter Rate"),
      startat: Yup.string().required("Please Pick Effective Date"),
      account: Yup.object().required("Please enter loan account").nullable(true),
      accountInterest: Yup.object().required("Please enter interest account").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getLoanTermLoading());
      if (isEdit) {
        const updateLoanTerm = {
          id: loanTerm ? loanTerm.id : 0,
          statusId: 1,
          description: values.description,
          name: values.name,
          startat: values.startat,
          period: values.period,
          amount: values.amount,
          position: values.position,
          interest: values.interest,
          interest_type: values.interest_type,
          clientId: values.client.value,
          companyId: values.company.value,
          accId: values.account.value,
          accInterestId: values.accountInterest.value,
        };
        dispatch(onUpdateLoanTerm(updateLoanTerm));
        validation.resetForm();
      } else {
        const newLoanTerm = {
          statusId: 1,
          description: values.description,
          name: values.name,
          startat: values.startat,
          period: values.period,
          amount: values.amount,
          position: values.position,
          interest: values.interest,
          interest_type: values.interest_type,
          clientId: values.client.value,
          companyId: values.company.value,
          accId: values.account.value,
          accInterestId: values.accountInterest.value,
        };
        dispatch(onAddNewLoanTerm(newLoanTerm));
        validation.resetForm();
      }
      toggle();
    },
  });

  document.title = "LoanTerms | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={loanTermList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteLoanTerm} onCloseClick={() => setDeleteModal(false)} />
      <ApproveModal data={loanTerm && loanTerm.loan_term_employee ? loanTerm.loan_term_employee.name + " - " + loanTerm.interest : ""} show={approveModal} onApproveClick={handleApproveEmployee} onCloseClick={() => setApproveModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Termin Pinjaman" pageTitle="Keuangan" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createLoanTerm") !== -1 ? "btn btn-primary add-btn me-2" : "d-none"}
              id="create-btn"
              onClick={() => {
                setLoanTerm("");
                setIsEdit(false);
                toggle();
              }}
            >
              <i className="ri-wallet-3-line me-1 align-bottom fs-14"></i> Tambah
            </button>
            <button className={userType === "admin" || userType === "client" || userType === "company" ? "btn me-2 btn-soft-danger" : userRole && userRole.split(",").indexOf("deleteLoanTerm") !== -1 ? "btn me-2 btn-soft-danger" : "d-none"} onClick={() => setDeleteModalMulti(true)}>
              <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Delete
            </button>
            <ExportDoc data={loanTermDoc} />
          </div>
        </BreadCrumb>
        <Row>
          <Col lg={12}>
            <Card id="loanTermList">
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className="ri-wallet-3-line me-1 align-bottom fs-14"></i> SEMUA TERMIN PINJAMAN
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={1}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={4}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={3}>
                            <div className="search-box mb-2">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Pilih Tanggal"
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(selectedDates, dateStr) => {
                                  setFilterDate(dateStr);
                                }}
                              />
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>

                          <Col sm={4} className="col-xxl-2">
                            <div className="me-2 mb-2 col-12">
                              <Select
                                placeholder="Pilih Status"
                                onChange={(e) => {
                                  setStatusActive(e);
                                }}
                                options={statusActiveData}
                                name="choices-single-default"
                              ></Select>
                            </div>
                          </Col>

                          <Col sm={2}>
                            <div>
                              <button
                                type="button"
                                className="btn btn-light w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line me-1 align-bottom fs-14"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex - 1);
                            previousPage();
                          }}
                          disabled={!canPreviousPage}
                        >
                          {" "}
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} of {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex + 1);
                            nextPage();
                          }}
                          disabled={!canNextPage}
                        >
                          {" "}
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Edit Loan Term" : "Tambah Termin Pinjaman"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <Label htmlFor="client-field" className="form-label">
                              Grup Usaha&nbsp;
                              {clientLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="client"
                              value={validation.values.client}
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              placeholder="Pilih Grup Usaha"
                              onChange={(e) => {
                                dispatch(setClientSelect(e));
                                validation.setFieldValue("client", e);
                                validation.setFieldValue("position", []);
                              }}
                              options={clientList}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="company-field" className="form-label">
                              Perusahaan&nbsp;
                              {companyLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="company"
                              value={validation.values.company}
                              placeholder="Pilih Perusahaan"
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              onChange={(e) => {
                                dispatch(setCompanySelect(e));
                                setPositionList([]);
                                validation.resetForm();
                                validation.setFieldValue("company", e);
                                validation.setFieldValue("position", []);
                              }}
                              options={companyList}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="name-field" className="form-label">
                              Nama
                            </Label>
                            <Input name="name" id="name-field" className="form-control" placeholder="Isi Termin Pinjaman" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name ?? ""} invalid={validation.touched.name && validation.errors.name ? true : false} />
                            {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                          </div>
                          <div className="mb-3 ">
                            <Label htmlFor="position" className="form-label">
                              Posisi yang Diizinkan
                              {positionLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="position"
                              value={validation.values.position}
                              placeholder="Pilih Posisi"
                              isMulti
                              onChange={(opt, { option }) => {
                                let newOpts = opt;
                                if (option && option.value === "all") {
                                  let filteredOptions = clone(positionList);
                                  filteredOptions = filteredOptions[0].options.filter((filteredOption) => !newOpts.includes(filteredOption));
                                  newOpts = newOpts.concat(filteredOptions).filter((newOpt) => newOpt.value !== "all");
                                }
                                validation.setFieldValue("position", newOpts);
                              }}
                              options={positionList}
                              invalid={validation.touched.position && validation.errors.position ? true : false}
                            ></Select>
                            {validation.touched.position && validation.errors.position ? (
                              <p className="text-danger" type="invalid">
                                {validation.errors.position}
                              </p>
                            ) : null}
                          </div>
                          <Row>
                            <div className="mb-3 col-lg-6">
                              <Label htmlFor="interest_type" className="form-label">
                                Jenis Bunga
                              </Label>
                              <Input name="interest_type" type="select" className="form-select" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.interest_type}>
                                {interestTypeData.map((item, key) => (
                                  <React.Fragment key={key}>
                                    {item.options.map((item, key) => (
                                      <option value={item.value} key={key}>
                                        {item.label}
                                      </option>
                                    ))}
                                  </React.Fragment>
                                ))}
                              </Input>
                            </div>
                            <div className="mb-3 col-lg-6">
                              <Label htmlFor="interest-field" className="form-label">
                                Suku Bunga
                              </Label>
                              <Input name="interest" id="interest-field" className="form-control" placeholder="Enter interest" type="number" onChange={validation.handleChange} onFocus={(e) => e.target.select()} onBlur={validation.handleBlur} value={validation.values.interest} invalid={validation.touched.interest && validation.errors.interest ? true : false} />
                              {validation.touched.interest && validation.errors.interest ? <FormFeedback type="invalid">{validation.errors.interest}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-6">
                              <Label htmlFor="period-field" className="form-label">
                                Tenor Pinjaman Maksimal (Bulan)
                              </Label>
                              <Input name="period" id="period-field" className="form-control" placeholder="Enter period" type="number" onChange={validation.handleChange} onFocus={(e) => e.target.select()} onBlur={validation.handleBlur} value={validation.values.period} invalid={validation.touched.period && validation.errors.period ? true : false} />
                              {validation.touched.period && validation.errors.period ? <FormFeedback type="invalid">{validation.errors.period}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-6">
                              <Label htmlFor="amount-field" className="form-label">
                                Jumlah Pinjaman Maksimal
                              </Label>
                              <Input name="amount" id="amount-field" className="form-control" placeholder="Enter amount" type="number" onChange={validation.handleChange} onFocus={(e) => e.target.select()} onBlur={validation.handleBlur} value={validation.values.amount} invalid={validation.touched.amount && validation.errors.amount ? true : false} />
                              {validation.touched.amount && validation.errors.amount ? <FormFeedback type="invalid">{validation.errors.amount}</FormFeedback> : null}
                            </div>
                          </Row>
                        </div>
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <Label htmlFor="date-field" className="form-label">
                              Tanggal Berlaku
                            </Label>
                            <Flatpickr
                              name="startat"
                              className="form-control"
                              placeholder="Pilih Tanggal"
                              options={{ enableTime: false, dateFormat: "Y/m/d" }}
                              value={validation.values.startat ?? ""}
                              onChange={(o, e) => {
                                validation.setFieldValue("startat", e);
                              }}
                            />
                            {validation.touched.startat && validation.errors.startat ? (
                              <p className="text-danger" type="invalid">
                                {validation.errors.startat}
                              </p>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <label className="form-label" htmlFor="account">
                              Receivable Account
                            </label>
                            <Select
                              name="account"
                              value={validation.values.account}
                              placeholder="Enter account"
                              onChange={(e) => {
                                validation.setFieldValue("account", e);
                              }}
                              options={accountingList}
                            ></Select>
                            {validation.touched.account && validation.errors.account && (
                              <small className="text-danger" type="invalid">
                                {validation.errors.account}
                              </small>
                            )}
                          </div>
                          <div className="mb-3">
                            <label className="form-label" htmlFor="accountInterest">
                              Interest Revenue Account
                            </label>
                            <Select
                              name="accountInterest"
                              value={validation.values.accountInterest}
                              placeholder="Enter account"
                              onChange={(e) => {
                                validation.setFieldValue("accountInterest", e);
                              }}
                              options={accountingList}
                            ></Select>
                            {validation.touched.accountInterest && validation.errors.accountInterest && (
                              <small className="text-danger" type="invalid">
                                {validation.errors.accountInterest}
                              </small>
                            )}
                          </div>
                          <div className="mb-4">
                            <Label htmlFor="description-field" className="form-label">
                              Keterangan
                            </Label>
                            <Input name="description" id="description-field" className="form-control" placeholder="Isi Keterangan" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description ?? ""} />
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}
                        >
                          Close
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{!!isEdit ? "Update" : "Tambah Pinjaman Termin"}</span>
                            {loading ? (
                              <Spinner size="sm" className="flex-shrink-0" role="name">
                                Loading...
                              </Spinner>
                            ) : (
                              ""
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default LoanTerm;
